class Event {
  /* eslint-enable indent */
  /**
   * name of the event
   */
  name;
  /**
   * scripting object id that owns this event
   */
  objectId;
  /**
   * unique id of the event
   */
  id;
  /**
   * Create an event object
   * @param {EventParam} param - parameters for creating an event
   */
  constructor(param) {
    const { name, objectId } = param;
    if (!name) throw new Error("Event name is required");
    if (!objectId) throw new Error("Scripting object id is required");
    this.objectId = objectId;
    this.name = name;
    this.id = `${this.objectId}.${this.name}`.toLowerCase();
  }
}
class ProxyEvent {
  /**
   * check if given object is an instance of ProxyEvent
   * @param obj object to be compared
   * @returns true if given object is an instance of ProxyEvent
   */
  static [Symbol.hasInstance](obj) {
    return typeof obj === "object" && obj !== null && "getType" in obj && typeof obj.getType === "function" && obj.getType() === "ProxyEvent";
  }
  /* eslint-enable indent */
  /**
   * module that owns this event management. SSF Guest or App Bridge host
   */
  #eventSrc;
  /**
   * unique id of scripting object
   */
  objectId;
  /**
   * name of the event
   */
  name;
  /**
   * unique id of the event
   */
  id;
  /**
   * get type of the object
   * @returns type of the object
   */
  getType() {
    return "ProxyEvent";
  }
  /**
   * Create a new instance of the Scripting Object Proxy Event
   * @param {ProxyEventParam} param - parameter for the constructor
   */
  constructor(param) {
    const { name, objectId, eventSrc } = param;
    if (!name) throw new Error("Event name is required");
    if (!objectId) throw new Error("Scripting object id is required");
    if (!eventSrc) throw new Error("Event source is required");
    this.objectId = objectId;
    this.name = name;
    this.#eventSrc = eventSrc;
    this.id = `${this.objectId}.${this.name}`.toLowerCase();
  }
  /**
   * subscribe to an scripting object event
   * @param callback event listener
   * @returns subscription token
   */
  subscribe = (callback) => this.#eventSrc.subscribe({
    eventId: this.id,
    callback
  });
  /**
   * unsubscribe from an scripting object event
   * @param token subscription token
   */
  unsubscribe = (token) => {
    this.#eventSrc.unsubscribe({
      eventId: this.id,
      token
    });
  };
}
const isEvent = (value) => value instanceof Event;
const getEventId = (objectId, eventName) => `${objectId.toLowerCase()}.${eventName.toLowerCase()}`;
export {
  Event,
  ProxyEvent,
  getEventId,
  isEvent
};
